import { useAdminProctorRequestListSearchParams } from '../../hooks';
import { InReviewAdminProctorRequestList } from '../in-review-admin-proctor-request-list';
import { RejectedAdminProctorRequestList } from '../rejected-admin-proctor-request-list';

export default function AdminProctorRequestList() {
  const [{ status }] = useAdminProctorRequestListSearchParams();

  switch (status) {
    case 'IN_REVIEW':
      return <InReviewAdminProctorRequestList />;
    case 'REJECTED':
      return <RejectedAdminProctorRequestList />;

    default:
      return null;
  }
}
